import { Route, Routes } from "react-router";
import PaymentList from "./PaymentList";
import PaymentEdit from "./PaymentEdit";

function PaymentsRoutes() {
  return (
    <Routes>
      <Route path="" element={<PaymentList />} />
      <Route path="edit" element={<PaymentEdit />} />
    </Routes>
  );
}

export default PaymentsRoutes;
